export default {
	methods: {
		_processListErrorMessage(error) {
			let errorMessage = error['error_message']
			this._.forEach(error['validation_errors'], function (message) {
				if (this._.includes(message, 'is not unique')) {
					errorMessage = this.$gettext('Jméno operátorského štítku není unikátní.');
					this.$refs['newoperatortagnameref'].setForcedInvalid(true, this.$gettext('Jméno musí být unikátní'));
				} else if (this._.includes(message, 'name must be set')) {
					errorMessage = this.$gettext('Jméno operátorského štítku musí být uvedeno.');
					this.$refs['newoperatortagnameref'].setForcedInvalid(true, this.$gettext('Zadejte název'));
				} else if (this._.includes(message, 'Unable to delete Operator tag')) {
					errorMessage = this.$gettext('Nelze smazat tag, pokud je přiřazený k nějakému operátorovi.');
				} else if (this._.includes(message, 'Operator tag\'s name is too short')) {
					errorMessage = this.$gettext('Jméno operátorského štítku musí být alespoň 2 znaky dlouhé.');
					this.$refs['newoperatortagnameref'].setForcedInvalid(true, this.$gettext('Minimálně 2 znaky'));
				} else{
					errorMessage = message;
				}
			}.bind(this));

			return errorMessage
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/operatorTags/mixins/operatorTags.js